import { getClaims } from "@workos-inc/authkit-react";

/**
 * Builds the same-origin WorkOS logout URL for an AuthKit access token.
 *
 * Navigating to this URL makes the existing chat-bridge proxy perform the
 * hosted-session logout as a primary browser navigation. It avoids relying on
 * AuthKit's background logout request, which is unavailable after some reloads
 * and must not be sent alongside this navigation.
 */
export function getWorkOSSessionLogoutUrl(
  accessToken: string,
  origin: string,
): string | null {
  try {
    const { sid: sessionId } = getClaims(accessToken);
    if (!sessionId) return null;

    const url = new URL("/user_management/sessions/logout", origin);
    url.searchParams.set("session_id", sessionId);
    return url.toString();
  } catch {
    return null;
  }
}
